import createReducer from 'helpers/reducers-helper';
import React, { useReducer } from 'react';
import repo from 'service/repository';
import assign from 'lodash/assign';
import { useAppContext, SHOW_APP_MESSAGE } from 'use-app';
import { showAppError } from 'helpers/error-handler';
import constate from 'constate';

const SHOW_LOADING = 'show_loading';
export const HIDE_LOADING = 'hide_loading';
export const SET_CURRENT_SELECT_PLATE_NUMBER = 'set_current_select_plate_number';
export const SET_PARKING_RECORD_LEAVE_DIALOG = 'set_parking_record_leave_dialog';
export const SET_PARKING_RECORD_CANCEL_DIALOG = 'set_parking_record_cancel_dialog';
export const SET_PARKING_RECORD_DIALOG = 'set_parking_record_dialog';

const useParkingRecord = () => {
  const { state: appState, dispatch: appDispatch, fetchParkingRecords } = useAppContext();
  const initState = {
    loading: false,
    currentSelectPlateNumber: '',
    parkingRecordDialog: false,
    parkingRecordLeaveDialog: false,
    parkingRecordCancelDialog: false,
  };

  const showLoading = state => assign({}, state, { loading: true });
  const hideLoading = state => assign({}, state, { loading: false });
  const setCurrentSelectPlateNumber = (state, payload) => ({ ...state, currentSelectPlateNumber: payload });
  const setParkingRecordDialog = (state, payload) => ({ ...state, parkingRecordDialog: payload });
  const setParkingRecordLeaveDialog = (state, payload) => ({ ...state, parkingRecordLeaveDialog: payload });
  const setParkingRecordCancelDialog = (state, payload) => ({ ...state, parkingRecordCancelDialog: payload });

  const reducer = createReducer(
    {
      [SHOW_LOADING]: showLoading,
      [HIDE_LOADING]: hideLoading,
      [SET_CURRENT_SELECT_PLATE_NUMBER]: setCurrentSelectPlateNumber,
      [SET_PARKING_RECORD_DIALOG]: setParkingRecordDialog,
      [SET_PARKING_RECORD_LEAVE_DIALOG]: setParkingRecordLeaveDialog,
      [SET_PARKING_RECORD_CANCEL_DIALOG]: setParkingRecordCancelDialog,
    },
    initState,
    true
  );
  const [state, dispatch] = useReducer(reducer, initState);

  const setParkingRecordLeave = () => {
    const parkingRecordId = appState.parkingRecord.find(
      record => record.plateNumber === state.currentSelectPlateNumber
    ).id;

    dispatch({ type: SHOW_LOADING });

    repo
      .parkingRecordLeave(parkingRecordId)
      .then(async () => {
        fetchParkingRecords();
        appDispatch({
          type: SHOW_APP_MESSAGE,
          payload: {
            type: 'success',
            message: (
              <>
                停車紀錄已關閉
                <br />
                您不會被收取此筆停車費用
              </>
            ),
          },
        });
      })
      .catch(error => {
        showAppError(
          appDispatch,
          error,
          <>
            停車紀錄關閉失敗
            <br />
            請洽詢麻吉客服
          </>
        );
        dispatch({ type: HIDE_LOADING });
      })
      .finally(() => {
        dispatch({ type: SET_PARKING_RECORD_LEAVE_DIALOG, payload: false });
      });
  };

  const setParkingRecordCancel = () => {
    const parkingRecordId = appState.parkingRecord.find(
      record => record.plateNumber === state.currentSelectPlateNumber
    ).id;

    dispatch({ type: SHOW_LOADING });

    repo
      .parkingRecordCancel(parkingRecordId)
      .then(async () => {
        fetchParkingRecords();
        appDispatch({
          type: SHOW_APP_MESSAGE,
          payload: {
            type: 'success',
            message: (
              <>
                停車紀錄已關閉
                <br />
                您不會被收取此筆停車費用
              </>
            ),
          },
        });
      })
      .catch(error => {
        showAppError(
          appDispatch,
          error,
          <>
            停車紀錄關閉失敗
            <br />
            請洽詢麻吉客服
          </>
        );
        dispatch({ type: HIDE_LOADING });
      })
      .finally(() => {
        dispatch({ type: SET_PARKING_RECORD_CANCEL_DIALOG, payload: false });
      });
  };

  return {
    state,
    dispatch,
    setParkingRecordLeave,
    setParkingRecordCancel,
  };
};

const [ParkingRecordProvider, useParkingRecordContext] = constate(useParkingRecord);

export { ParkingRecordProvider, useParkingRecordContext };
